import React, { useEffect, useState } from 'react';
import { learnerApi } from '../../api/client';
import Spinner from '../../components/common/Spinner';

export default function LearnerAttendance() {
  const [month,   setMonth]   = useState(new Date().toISOString().slice(0, 7));
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    learnerApi.getAttendance(month)
      .then(r => setData(r.data.data))
      .finally(() => setLoading(false));
  }, [month]);

  const STATUS_STYLE = {
    present: { bg: '#d1fae5', color: '#065f46', label: 'Present' },
    absent:  { bg: '#fee2e2', color: '#991b1b', label: 'Absent' },
    late:    { bg: '#fef3c7', color: '#92400e', label: 'Late' },
    excused: { bg: '#ede9fe', color: '#5b21b6', label: 'Excused' },
  };

  const summary = data?.summary;
  const pct     = summary?.attendance_percentage;

  return (
    <div>
      <div className="page-header"><h2>My Attendance</h2></div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20, alignItems: 'center' }}>
        <input className="sms-input" type="month" value={month} onChange={e => setMonth(e.target.value)} style={{ width: 180 }} />
      </div>

      {loading ? <Spinner /> : data && (
        <>
          {/* Summary */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))', gap: 12, marginBottom: 24 }}>
            {[
              ['Total Days',  summary?.total,   '#6b7280'],
              ['Present',     summary?.present, '#10b981'],
              ['Absent',      summary?.absent,  '#ef4444'],
              ['Late',        summary?.late,    '#f59e0b'],
              ['Attendance',  pct !== undefined ? `${pct}%` : '—', pct >= 75 ? '#10b981' : pct >= 50 ? '#f59e0b' : '#ef4444'],
            ].map(([l, v, c]) => (
              <div key={l} style={{ background: '#fff', borderRadius: 12, padding: 16, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: `1px solid ${c}22` }}>
                <div style={{ fontSize: '1.6rem', fontWeight: 700, color: c }}>{v}</div>
                <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>{l}</div>
              </div>
            ))}
          </div>

          {/* Calendar grid */}
          <div className="sms-card">
            <h5 style={{ fontWeight: 600, marginBottom: 16 }}>Daily Record — {new Date(month + '-01').toLocaleString('en', { month: 'long', year: 'numeric' })}</h5>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 8 }}>
              {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(d => (
                <div key={d} style={{ textAlign: 'center', fontSize: '0.75rem', fontWeight: 600, color: '#9ca3af', padding: '4px 0' }}>{d}</div>
              ))}
              {/* Empty slots for first day of month */}
              {Array.from({ length: new Date(month + '-01').getDay() }, (_, i) => (
                <div key={`empty-${i}`} />
              ))}
              {/* Days */}
              {Array.from({ length: new Date(month.split('-')[0], month.split('-')[1], 0).getDate() }, (_, i) => {
                const day   = String(i + 1).padStart(2, '0');
                const date  = `${month}-${day}`;
                const rec   = data.records.find(r => r.date === date);
                const style = rec ? STATUS_STYLE[rec.status] : null;
                const isWeekend = [0, 6].includes(new Date(date).getDay());
                return (
                  <div key={day} style={{
                    textAlign: 'center', padding: '8px 4px', borderRadius: 8,
                    background: style ? style.bg : isWeekend ? '#f9fafb' : '#fff',
                    border: `1px solid ${style ? style.bg : '#e5e7eb'}`,
                    fontSize: '0.85rem',
                  }}>
                    <div style={{ fontWeight: 600, color: style ? style.color : isWeekend ? '#d1d5db' : '#374151' }}>{i + 1}</div>
                    {style && <div style={{ fontSize: '0.65rem', color: style.color, fontWeight: 500 }}>{style.label}</div>}
                    {rec?.note && <div style={{ fontSize: '0.6rem', color: '#6b7280' }}>{rec.note}</div>}
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
